import { api, ApiError } from './api';

/**
 * Approved for repair — TODOS los botones pasan por aquí para que el comportamiento sea uno solo.
 *
 * El backend clasifica con los números que la IA YA leyó del estimado del seguro (no se vuelve a
 * leer): pago neto positivo → 'Waiting repair Check' (se persigue el cheque) · negativo o menor
 * que el deducible → 'Repair (No Payment to HO or CO)'. Si el claim no tiene números, el backend
 * responde 409 y AQUÍ se le pregunta a quien apretó (pedido del dueño: "si apretamos el botón sin
 * estimado, pregunta al apretar").
 */
export async function approveForRepair(
  claimId: string,
  askMessage: string,
): Promise<{ status: string; payment: 'waiting' | 'none' }> {
  try {
    return await api.post(`/api/claims/${claimId}/approved-for-repair`, {});
  } catch (e) {
    if (e instanceof ApiError && (e.code === 'no_estimate_numbers' || e.message === 'no_estimate_numbers')) {
      const waiting = window.confirm(askMessage);
      return await api.post(`/api/claims/${claimId}/approved-for-repair`, { payment: waiting ? 'waiting' : 'none' });
    }
    throw e;
  }
}
